import React, { Component } from 'react';
import { HeaderWrapper, HeaderPlaceHolder } from './styles';

class Header extends Component {
  render() {
    return (
      <HeaderPlaceHolder>
        <HeaderWrapper>
          <a className="lyearnLogo" id="lyearnlogo" href="https://www.lyearn.com">
            <img
              src="https://dndw32r4edmw5.cloudfront.net/lyearn/lyearnWebsite/images/lyearn-gray-logo.png"
              alt="Lyearn"
              className="logoImage"
            />
          </a>
        </HeaderWrapper>
      </HeaderPlaceHolder>
    );
  }
}

export default Header;
